import LocalStorageHelper from '../common/localStorageHelper'
import * as config from '../data/config'

class AuthenticationApi {
    
    static validateToken(token) { 
        //console.log("token",token)         
        
        let api = config.environment.api
        let url = api.baseURL + api.validateTokenURL
        
        return fetch(
            url,
            { headers: { 'Authorization': token } })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                else {
                 
                    return false;
                }
            }).then(payload => {
                return payload === true;
            }).catch(err=>{
                
                console.log(err)
            })
    }

    static logOut(token) {
        let api = config.environment.api
        let url = api.baseURL + api.logOutURL
        return fetch(
            url,
            { headers: { 'Authorization': token } })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    // Not valid
                    return false;
                }
            }).then(payload => {
                return payload === true;
            });
    }
}

export default AuthenticationApi